<template>
  <div>
    <div class="content-tabs-wrapper">
      <Tabs justified class="dashboard-tabs" @change="handleAfterChange">
        <!-- Sent & Received -->
        <Tab>
          <div slot="title">
            <fai :icon="['fas', 'paper-plane']" class='mr-1' />sent and received
          </div>
          <SentReceivedContainer v-if="activeTab === 0" :active="activeTab === 0" />
        </Tab>
        <!-- Current Scores -->
        <Tab>
          <div slot="title">
            <fai :icon="['far', 'calendar-alt']" class='mr-1' />current scores
          </div>
          <TypeScoringContainer v-if="activeTab === 1" :active="activeTab === 1" />
        </Tab>

        <!-- Scores Summary -->
        <Tab>
          <div slot="title">
            <fai :icon="['far', 'chart-bar']" class='mr-1' />scores summary
          </div>
          <ScoresContainer v-if="activeTab === 2" :active="activeTab === 2" />
        </Tab>

        <!-- Important Feedback -->
        <Tab>
          <div slot="title">
            <fai :icon="['fas', 'bullhorn']" class='mr-1' />important feedback
          </div>
          <ImportantFeedbackContainer v-if="activeTab === 3" :active="activeTab === 3"/>
        </Tab>

        <!-- Reporting  -->
        <Tab>
          <div slot="title">
            <fai :icon="['fas', 'download']" class='mr-1' />feedback report
          </div>
          <ReportingContainer v-if="activeTab === 4" :active="activeTab === 4" />
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
  import SentReceivedContainer from './Tabs/SentReceivedContainer';
  import TypeScoringContainer from './Tabs/TypeScoringContainer';
  import ScoresContainer from './Tabs/ScoresContainer';
  import ImportantFeedbackContainer from './Tabs/ImportantFeedbackContainer';
  import ReportingContainer from './Tabs/ReportingContainer';
  import { Tabs, Tab, Tooltip } from 'uiv';

  export default {
    name: 'DashboardLandingPage',
    components: {
      SentReceivedContainer,
      TypeScoringContainer,
      ScoresContainer,
      ImportantFeedbackContainer,
      ReportingContainer,
      Tab,
      Tabs,
      Tooltip
    },
    data() {
      return {
        activeTab: 0
      }
    },
    methods: {
      handleAfterChange(index) {
        this.activeTab = index;
      }
    }
  }

</script>
